<template>
  <div class="basic-range-input-container">
    <span class="min-max">{{ min }}</span><span class="min-max">{{ max }}</span>
    <Field
      v-slot="{ field }"
      v-model="mutatedValue"
      :label="label"
      :name="name"
      :rules="validation"
    >
      <input
        :ref="name"
        type="range"
        :min="min"
        :max="max"
        :step="step"
        v-bind="field"
        class="range"
        @input="onInput"
      >
      <span class="value-displayed">{{ mutatedValue }}</span>
      <ErrorMessage
        class="error-msg"
        :name="name"
      />
    </Field>
  </div>
</template>

<script>
import { Field, ErrorMessage } from 'vee-validate'
/**
 * Props:
 * value: value that'll be displayed on the range at loadin ([String, Number]),
 * name: input's name (String),
 * min: minimum of the range (Number),
 * max: maximum of the range (Number),
 * step: step of the range (Number)
 */
export default {
  name: 'BasicRangeInput',
  components: {
    Field,
    ErrorMessage
  },
  props: {
    label: String,
    validation: [String, Boolean],
    defaultValue: [String, Number, Array],
    name: String,
    min: [Number, String],
    max: [Number, String],
    step: [Number, String]
  },
  emits: ['addData'],
  data() {
    return {
      mutatedValue: this.defaultValue
    }
  },
  mounted() {
    this.mutatedValue
      ? this.$emit('addData', { value: this.mutatedValue, name: this.name })
      : this.$emit('addData', { value: '', name: this.name })
  },
  methods: {
    onInput({ target }) {
      this.$emit('addData', { value: target.value, name: this.name })
    }
  }
}
</script>

<style lang="scss" scoped>
  .basic-range-input-container {
    margin: 10px 0;

    /* Tablet (portrait) */
    @media only screen and (width >= 768px) {
      margin: 20px 0;
    }

    /* Desktops and laptops */
    @media only screen and (width >= 1024px) {
      margin: 20px 0;
    }

    /* Large screens */
    @media only screen and (width >= 1824px) {
      margin: 20px 0;
    }

    span.min-max {
      font-size: 12px;
      color: rgb(0 0 0 / 30%);
    }

    span.value-displayed {
      font-size: 16px;
      color: #010101;
    }

    input[type='range'] {
      -webkit-appearance: none;
      appearance: none;
      width: 100%;
      margin: 10px 0 15px;
    }

    input[type='range']:focus {
      outline: none;
    }

    input[type='range']::-webkit-slider-runnable-track {
      width: 100%;
      height: 8.4px;
      box-shadow:
        1px 1px 1px rgb(0 0 0 / 0%),
        0 0 1px rgb(13 13 13 / 0%);
      background: rgb(0 0 0 / 20%);
      border-radius: 15.3px;
      border: 0.2px solid #010101;
    }

    input[type='range']::-webkit-slider-thumb {
      height: 25px;
      width: 25px;
      border-radius: 15px;
      background: #cca256;
      -webkit-appearance: none;
      appearance: none;
      margin-top: -8.5px;
    }

    input[type='range']:focus::-webkit-slider-runnable-track {
      background: rgb(13 13 13 / 20%);
    }

    input[type='range']::-moz-range-track {
      width: 100%;
      height: 8.4px;
      box-shadow:
        1px 1px 1px rgb(0 0 0 / 0%),
        0 0 1px rgb(13 13 13 / 0%);
      background: rgb(0 0 0 / 20%);
      border-radius: 15.3px;
      border: 0.2px solid #010101;
    }

    input[type='range']::-moz-range-thumb {
      height: 25px;
      width: 25px;
      border-radius: 10px;
      background: #cca256;
    }

    input[type='range']::-ms-track {
      width: 100%;
      height: 8.4px;
      background: transparent;
      border-color: transparent;
      color: transparent;
    }

    input[type='range']::-ms-fill-lower {
      background: rgb(0 0 0 / 20%);
      border: 0.2px solid #010101;
      border-radius: 10px;
      box-shadow:
        1px 1px 1px rgb(0 0 0 / 0%),
        0 0 1px rgb(13 13 13 / 0%);
    }

    input[type='range']::-ms-fill-upper {
      background: rgb(0 0 0 / 20%);
      border: 0.2px solid #010101;
      border-radius: 10px;
      box-shadow:
        1px 1px 1px rgb(0 0 0 / 0%),
        0 0 1px rgb(13 13 13 / 0%);
    }

    input[type='range']::-ms-thumb {
      width: 25px;
      border-radius: 10px;
      background: #cca256;
      height: 8.4px;
    }

    input[type='range']:focus::-ms-fill-lower {
      background: rgb(0 0 0 / 20%);
    }

    input[type='range']:focus::-ms-fill-upper {
      background: rgb(13 13 13 / 20%);
    }
  }
</style>
